import { AdminPageHeader } from '@/components/patterns/admin-page'
import TerminalForm from '@/components/forms/TerminalForm'
import { adminRouteTitleHead } from '@/lib/admin-route-title'
import { terminalQueries, useTerminal } from '@/lib/services/terminals/terminals.query'
import { locationFilters, locationQueries } from '@/lib/services/locations/locations.query'
import { assertNotSalesDemoOrganization } from '@/lib/services/sales-demos/sales-demos.guard'
import { createFileRoute, notFound } from '@tanstack/react-router'
import { CreditCard } from 'lucide-react'
import {
  terminalSearchSchema,
  assertTerminalAccountAccess,
} from '@/lib/services/terminals/terminals.schema'

const filters = locationFilters().get()

export const Route = createFileRoute('/_authenticated/$orgId/settings/terminals/$terminalId')({
  component: RouteComponent,
  head: adminRouteTitleHead,
  validateSearch: terminalSearchSchema,
  loaderDeps: ({ search }) => ({ accountContext: search.accountContext }),
  loader: async ({ context, params, deps = {} }) => {
    if (!context.ability.can('view', 'terminals')) throw notFound()
    assertTerminalAccountAccess(context.ability, deps.accountContext)

    await assertNotSalesDemoOrganization(context.queryClient, params.orgId)
    const terminal = await context.queryClient.ensureQueryData(
      terminalQueries.show({
        organizationId: params.orgId,
        terminalId: params.terminalId,
        accountContext: deps.accountContext,
      })
    )
    void context.queryClient.ensureQueryData(
      locationQueries.index({ organizationId: params.orgId, filters })
    )
    return { terminal, isReadOnly: !context.ability.can('edit', 'terminals') }
  },
})

function RouteComponent() {
  const { terminalId } = Route.useParams()
  const { accountContext } = Route.useSearch()
  const { data: terminal } = useTerminal(terminalId, { accountContext })

  return (
    <div className="space-y-4 max-w-4xl">
      <AdminPageHeader icon={CreditCard} title="Terminal Details" />
      <TerminalForm
        key={`${accountContext}:${terminalId}`}
        initialData={terminal}
        accountContext={accountContext}
      />
    </div>
  )
}
